import React from 'react'
import { useRouteError } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Typography from '@mui/material/Typography';

const ErrorBoundary = () => {
  let error = useRouteError();
  console.error(error);

  return (
    <div className='p-4'>
      <div className='flex flex-col gap-2 items-center justify-center py-4 px-6 border border-muted rounded text-muted-foreground shadow'>
        <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} className='text-muted text-8xl' />
        <Typography variant='inherit' className='text-xl'>
          Something went wrong
        </Typography>
        { error?.stack &&
          <div className='bg-muted px-4 py-2 rounded'>
            <Typography variant='inherit' className='text-sm '>
              {error.stack}
            </Typography>
          </div>
        }
      </div>
    </div>
  )
}

export default ErrorBoundary